module.exports = "pegasus_template/assets/hexline-twitter.gif";